// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-04-24
import React from 'react';
import Overlay from '../../content/images/PreviewOverlayV6.png';
import FrenchOverlay from '../../content/images/PreviewOverlayFrench.png';
import css from './PreviewOverlay.module.scss';


export interface IProps {
    locale: string;
}

/** Renders a semi-transparent overlay image indicating the app is in Preview Mode.
 * Switches to a French image when locale is 'fr-CA'. */
const PreviewOverlay = (props: IProps) => {
    const { locale } = props;

    // Alt text is hardcoded intentionally — this component renders before the
    // localization strings system is initialized, so strings.* is unavailable here.
    // English is the universal default for all non-French locales.
    const isFrench = locale === 'fr-CA';
    const overlay = isFrench ? FrenchOverlay : Overlay;
    const altText = isFrench ? 'Mode Aperçu' : 'Preview Mode Overlay';

    return (
        <div className={css.previewOverlay}>
            <img src={overlay} className={css.previewImg} alt={altText} />
        </div>
    );
};

export default PreviewOverlay;
